import React from 'react'
import css from './Reports.scss'
import SortableTable from 'SF/table/SortableTable'
import ReportRow from './ReportRow'
import PropTypes from 'prop-types'
import Checkbox from "../SF/Checkbox"
import StyledButton from "../common/StyledButton";
import Footer from "../common/Footer";

/**
 * Represents the table displayed on the Data Extracts Tenant Admin page under the Files tab. This table allows a
 * tenant to configure which files (aka reports) to include in data extracts. This tab is displayed only if data
 * extracts are enabled for the tenant.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The files table in the tenant admin Data Extracts page
 */
const Reports = (props) => {

    const getSelectAllChecked = () => {
        // Set select all checkbox to true if all checkboxes read from the database are true
        let selectAllReports = true
        props.reportsList.forEach( report => {
            if (!report.enabled) {
                selectAllReports = false
            }
        })
        return selectAllReports
    }

    const getHeaders = () => {
        const headers = []
        headers.push(
            {content: <Checkbox className={css['checkbox']}
                                id="select-all-checkbox"
                                data-testid="select-all-checkbox"
                                ariaLabel="select-all-checkbox"
                                onChange={props.onSelectAllChange}
                                checked={getSelectAllChecked()} />},
            {content: 'File'},
            {content: 'Description'}
        )
        return headers
    }

    const renderReport = (report, index) => {
        return <ReportRow {...report}
                          index={index}
                          onChange={props.onReportChange}
                          key={index}/>
    }

    const getReportsTable = () => {
        if (typeof props.reportsList === 'undefined' ||
            props.reportsList.length === 0 ||
            !Array.isArray(props.reportsList)) {
            return <div
                className={css['no-reports']}>No reports available</div>
        } else {
            return (
                <div>
                    <SortableTable columnToSort="File"
                                   headers={getHeaders()}
                                   items={props.reportsList}
                                   shouldPaginate={false}
                                   renderItem={renderReport}/>
                </div>
            )
        }
    }

    return (
        <div className={css['reports']}>
            <div className={css['tab-header']}>Files</div>
            <p className={css['report-instruction']}>Please select files to include in data extracts:</p>
            {getReportsTable()}
            <Footer
                className={css['footer']}
                primaryButton={<StyledButton onClick={props.saveReports}>SAVE FILES</StyledButton>}
                secondaryButton={<StyledButton asLink onClick={() => props.setIsOpen(true)}>CLEAR CHANGES</StyledButton>}
            />
        </div>
    )
}

Reports.propTypes = {
    reportsList: PropTypes.arrayOf(PropTypes.object),
    onReportChange: PropTypes.func.isRequired,
    onSelectAllChange: PropTypes.func.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    saveReports: PropTypes.func.isRequired
}

export default Reports
